module.exports = __webpack_public_path__ + "static/media/dec_img.079cfcd4.svg";